import { useEffect, useState } from "react";
import { useLocation, useNavigate, useOutletContext, useParams } from "react-router-dom";
import { Col, Divider, Radio, Row } from "antd";
import { getKubeService } from "../../backend";
import SolutionTemplates from "../../components/SolutionTemplates";
import { GetMicroservicesResponseMicroservices } from "@microtica/ms-kube-sdk";
import GridList from "../../components/GridList";
import TemplateAvatar from "../../components/TemplateAvatar";
import { TEMPLATES } from "../../enums/enums";
import { IEnvDetails } from "../../types";

const EnvironmentAddApp = () => {
    const { projectId, envId } = useParams();
    const { envDetails } = useOutletContext<{ envDetails: IEnvDetails }>();
    const navigate = useNavigate();
    const redirectToAppsPage = (useLocation().state as { redirectToAppsPage: string } | undefined)?.redirectToAppsPage;
    const [services, setServices] = useState<GetMicroservicesResponseMicroservices[]>([]);
    const [appType, setAppType] = useState<"templates" | "fromArchive">("templates");

    useEffect(() => {
        loadData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        // navigate to /apps page if user didn't have any apps but a notification for a deployed app was received
        if (!!redirectToAppsPage && !!envDetails.deployedMicroservices.length) {
            navigate(`/projects/${projectId}/environments/${envId}/apps`);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [envDetails.deployedMicroservices.length]);

    const loadData = async () => {
        const { data: { microservices } } = await getKubeService().getMicroservices(projectId!);
        setServices(microservices);
    }

    const renderContent = () => {
        switch (appType) {
            case "templates":
                return <SolutionTemplates dataSource={TEMPLATES} />;
            case "fromArchive":
                return <GridList
                    itemsInRow={4}
                    navigateState={services.reduce((prev, curr) => {
                        return {
                            state: {
                                ...prev.state,
                                [curr.name]: curr
                            }
                        };
                    }, { state: {} })}
                    dataSource={services.map(item => {
                        return {
                            key: item.id,
                            title: item.name,
                            description: item.description,
                            avatar: <TemplateAvatar name={item.name} size="large" shape="square" />,
                            link: `/projects/${projectId}/environments/${envId}/apps/${item.name}/deploy`
                        }
                    })}></GridList>;
        }
    }

    return (
        <>
            {/** App type choice */}
            <Row>
                <Col span={24}>
                    <Radio.Group
                        defaultValue="templates"
                        style={{ width: "100%", display: "flex", justifyContent: "space-between" }}
                        onChange={(e) => {
                            setAppType(e.target.value);
                        }}>
                        <Radio value="templates" className={`app-type-radio ${appType === "templates" ? "app-type-radio-selected" : ''}`}>
                            <div style={{ fontWeight: "bold" }}>
                                App Templates
                            </div>
                            <div>
                                Choose from our ready-made templates to get started
                            </div>
                        </Radio>
                        <Radio value="fromArchive" className={`app-type-radio ${appType === "fromArchive" ? "app-type-radio-selected" : ''}`}>
                            <div style={{ fontWeight: "bold" }}>
                                My Apps
                            </div>
                            <div>
                                Configure and deploy an app that you already created
                            </div>
                        </Radio>
                    </Radio.Group>
                </Col>
            </Row>

            <Divider />

            {
                renderContent()
            }
        </>
    );
}

export default EnvironmentAddApp;